import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
@Component({
  selector: 'dmmp-article-topics-desktop',
  templateUrl: './article-topics-desktop.component.html',
})
export class ArticleTopicsDesktopComponent implements OnInit {
  @Input() vocabularies: any
  @Input() configCarousel: object
  @Output() redirectPage = new EventEmitter()
  carouselVocabularies = []

  ngOnInit(): void {
    const lengthSlide = 8
    if (this.vocabularies?.length > 8) {
      for (let i = 0; i < this.vocabularies?.length; i += lengthSlide) {
        const slide = this.vocabularies.slice(i, i + lengthSlide)
        this.carouselVocabularies.push({ slide: slide })
      }
    }
  }
}
